/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { CancelContactRequestReasonCode } from './cancelContactRequestReasonCode';

export interface CancelContactRequest {
  reason_code?: CancelContactRequestReasonCode;
  message?: string | null;
}
